<template>
  <div class="progress">
    <div class="header">
      <h2>Plan Progress</h2>
      <span>{{ planProgressPercent }}% of the year complete</span>
    </div>
    <div class="progress-bar">
      <div
        class="progress-fill"
        :style="`width: ${planProgressPercent}%`"
      />
    </div>
    <span class="plan-name">{{ props.statement.current.statement_data.plan.name }}</span>
    <h2>{{ props.statement.current.statement_data.forecast.label }}: {{ props.statement.current.statement_data.client.performance.position.label }}</h2>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  statement: {
    type: Object,
    required: true,
  },
});
const planStart = new Date(props.statement.current.statement_data.plan.dates.start);
const planEnd = new Date(props.statement.current.statement_data.plan.dates.end);
const oneDayMs = 24 * 60 * 60 * 1000;
const planLengthMs = planEnd - planStart - oneDayMs; // subtract one day to adjust for last day of plan
const todayDate = new Date();
const planCurrentMs = (todayDate > (planEnd - oneDayMs) ? (planEnd - oneDayMs) : todayDate) - planStart; // cap at 100% progress
const planProgressPercent = Math.round((planCurrentMs / planLengthMs) * 100);
</script>

<style scoped lang="scss">
@use "../../../scss/_variables.scss";
.progress {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
  border: 1px solid variables.$charcoal-tint-20;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  @media screen and (min-width: 851px) {
    width: 49%;
  }
  h2 {
    margin-bottom: 0;
  }

  .header {
    span {
      font-weight: bold;
    }
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .progress-bar, .progress-fill {
    height: 12px;
    background-color: variables.$color-background-tertiary;
    border-radius: 6px;
  }

  .progress-fill {
    position: relative;
    z-index: 1;
    background-color: variables.$vl-light-blue;
    width: 50%;
  }

  .plan-name {
    font-size: 20px;
  }
}
</style>